<template>
  <el-form :model="form" ref="form" status-icon label-position="top" label-width="110px" size="medium" class="form">
    <el-form-item label="">
      <el-checkbox v-model="form.cliente">Cliente</el-checkbox>
      <el-checkbox v-model="form.vendedor">Vendedor</el-checkbox>
      <el-checkbox v-model="form.proveedor">Proveedor</el-checkbox>
    </el-form-item>
    <el-form-item label="Documento/Nit" prop="documento" :rules="[{ required: true, message: 'Campo Obligatorio' }]">
      <el-input type="text" v-model="form.documento" autocomplete="off"></el-input>
    </el-form-item>
    <el-form-item label="Nombre" prop="nombre" :rules="[{ required: true, message: 'Campo Obligatorio' }]">
      <el-input type="text" v-model="form.nombre" autocomplete="off"></el-input>
    </el-form-item>
    <el-form-item label="Dirección" prop="direccion" :rules="[{ required: true, message: 'Campo Obligatorio' }]">
      <el-input type="text" v-model="form.direccion" autocomplete="off"></el-input>
    </el-form-item>
    <el-form-item label="Ciudad" prop="ciudad" :rules="[{ required: true, message: 'Campo Obligatorio' }]">
      <el-input type="text" v-model="form.ciudad" autocomplete="off"></el-input>
    </el-form-item>
    <el-form-item label="Email" prop="email" :rules="[{ required: true, message: 'Campo Obligatorio' }]">
      <el-input type="text" v-model="form.email" autocomplete="off"></el-input>
    </el-form-item>
    <el-form-item label="Teléfono" prop="telefono">
      <el-input type="text" v-model="form.telefono" autocomplete="off"></el-input>
    </el-form-item>
    <el-form-item label="Situación fiscal" prop="telefono">
      <el-upload class="upload-demo" ref="upload" accept=".pdf" :file-list="fileList" :limit="1" :action="baseURL"
        :auto-upload="false" :on-change="handleChange" :on-remove="handleRemove" :on-success="handleSuccess">
        <el-button slot="trigger" size="small" type="primary">Selecciona un archivo</el-button>
        <!-- <el-button style="margin-left: 10px;" size="small" type="success" @click="submitUpload">Cargar al
          servidor</el-button> -->
        <div slot="tip" class="el-upload__tip">Solo archivos pdf con un tamaño menor de 500kb</div>
      </el-upload>
    </el-form-item>
    <el-form-item v-if="form.cliente" label="Nacimiento" prop="nacimiento">
      <el-date-picker v-model="form.nacimiento" type="date" format="yyyy/MM/dd" value-format="yyyy-MM-dd"
        placeholder="Selecciona">
      </el-date-picker>
    </el-form-item>
  </el-form>
</template>

<script>
import { mapMutations, mapActions } from 'vuex'
import { store, update, edit, deleteDocument } from "@/api/person";
export default {
  data() {
    return {
      baseUrl: process.env.VUE_APP_ROOT_API,
      loading: false,
      baseURL: '',
      thirdId: '',
      form: {
        documento: "",
        nombre: "",
        direccion: "",
        ciudad: "",
        email: "",
        telefono: "",
        nacimiento: "",
        cliente: null,
        vendedor: null,
        proveedor: null,
      },
      file: null,
      fileList: []
    };
  },
  props: ['payload'],
  created() {
    let me = this
    if (me.payload.field_id)
      me.editThrid(me.payload.field_id)

    bus.$on("save", function (payload) {
      me.submitForm();
    });
    bus.$on("update", function (payload) {
      me.submitForm();
    });
    bus.$on("cancel", function (payload) {
      me.resetForm();
      bus.$emit("close");
    });
  },
  methods: {
    ...mapMutations(['SET_RESPONSE', 'setRightMenuDrawer']),
    ...mapActions('third', ['getAllAction']),
    ...mapActions(['showErrors']),
    handleChange(file, fileList) {
      this.file = file
    },
    handleRemove(file, fileList) {
      if (file.edit) {
        deleteDocument(this.thirdId)
          .then(({ data }) => {
            if (data.code == 200) {
              this.SET_RESPONSE({ type: 'success', msg: 'El archivo ha sido eliminado' })
              this.getAllAction();
            } else {
              this.SET_RESPONSE({ type: 'error', msg: data.message })
            }
            this.file = null
          })
          .catch(function (error) {
            console.log(error);
            this.$message({
              type: "error",
              message: "Error! ",
            });
          });
      } else {
        this.file = null
      }
    },
    handleSuccess(response, file, fileList) {
      if (response.code === 200) {
        this.setRightMenuDrawer(false)
        this.getAllAction();
      } else {
        this.SET_RESPONSE({ type: 'error', msg: 'No se pudo cargar el archivo' })
        this.$refs.upload.clearFiles()
      }
    },
    async submitUpload() {
      let me = this;
      this.baseURL =
        process.env.VUE_APP_ROOT_API + "/person/uploadDocument/" + this.thirdId;
      setTimeout(() => {
        me.$refs.upload.submit();
      }, 800);
    },
    submitForm() {
      try {
        this.$refs['form'].validate((valid) => {
          if (valid) {
            if (this.payload.edit) {
              this.updateForm();
            } else {
              this.saveForm();
            }
          } else {
            console.log("error submit!!");
            return false;
          }
        });
      } catch (error) {
        console.log(error);
      }
    },
    async saveForm() {
      try {
        let { data } = await store(this.form)
        if (data.code === 200) {
          this.thirdId = data.data.id
          await this.submitUpload();
          this.SET_RESPONSE({ type: 'success', msg: 'Tercero guardado.' })
          if (this.file === null) {
            this.setRightMenuDrawer(false)
            await this.getAllAction();
          }
        } else {
          this.SET_RESPONSE({ type: 'error', msg: 'Error al guardar.' })
        }
      } catch (error) {
        if (error.response.status == 422)
          this.showErrors(error.response.data.errors)
      }
    },
    async updateForm() {
      try {
        let me = this
        this.thirdId = this.form.id
        let { data } = await update(this.form)
        if (data.code === 200) {
          await this.submitUpload()
          this.SET_RESPONSE({ type: 'success', msg: 'Tercero actualizado.' })
          if (this.file === null) {
            this.setRightMenuDrawer(false)
          }
          await this.getAllAction();
        } else {
          this.SET_RESPONSE({ type: 'error', msg: 'Error al actualizar.' })
        }
      } catch (error) {
        console.log('Error: ', error);
        if (error.response.status == 422)
          this.showErrors(error.response.data.errors)
      }
    },
    resetForm() {
      this.$refs['form'].resetFields();
      this.form.id = "";
      this.form.cliente = null;
      this.form.vendedor = null;
      this.form.proveedor = null;
    },
    async editThrid(id) {
      try {
        this.editing = true
        this.fileList = []
        let data = await edit(id)
        this.form = data.data
        this.thirdId = data.data.id
        if (data.data.cliente == '1') {
          this.form.cliente = true
        }
        if (data.data.vendedor == '1') {
          this.form.vendedor = true
        }
        if (data.data.proveedor == '1') {
          this.form.proveedor = true
        }
        if (data.data.file_tax_situation) {
          this.fileList.push({ name: data.data.file_tax_situation, edit: true });
        }
      } catch (error) {
        console.log(error);
      }
    }
  }
}
</script>